import {bodyLock} from "./module";

export function mobileNavigation() {
    const _window = this._window;
    const _document = this._document;
    const mainWrap = this.mainWrap;
    const menuWrap = _document.querySelector(".menu-wrap");
    const menuLinks = menuWrap ? menuWrap.querySelectorAll("a") : null;
    const menuBtn = _document.querySelector(".menu-btn");
    let windowWidth = _window.innerWidth;
    let scrolled = _window.scrollY || _window.pageYOffset;
    let contentPosition = 0;
    let flag = false;
    let resizeTimeout;

    function toggleNav() {
        flag = !flag;
        if(flag) {
            contentPosition = scrolled;
            mainWrap.classList.add("mobile-menu-is-open");
            bodyLock.lockBody();
        } else {
            mainWrap.classList.remove("mobile-menu-is-open");
            document.querySelector("html, body").scrollTop = contentPosition;
            bodyLock.unlockBody();
        }
    }

    [...menuLinks].forEach((link) => {
        link.addEventListener("click", () => {
            windowWidth = _window.innerWidth;
            if(windowWidth < 1200) {
                toggleNav();
            }
        });
    });

    _window.addEventListener("resize", function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            if(mainWrap.classList.contains("mobile-menu-is-open")) {
                toggleNav();
            }
        }, 500);
    }, true);

    _window.addEventListener("scroll", () => {
        scrolled = _window.scrollY || window.pageYOffset;
    });

    menuBtn && menuBtn.addEventListener("click", function () {
        toggleNav();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobile-navigation.js